import Product from './product/product'
const SUB_SYSTEM = 'product'
// 产品管理
export const productApi = new Product(SUB_SYSTEM, 'platform')
export const fundsproviderApi = new Product(SUB_SYSTEM, 'fundsprovider')
export const suppliersApi = new Product(SUB_SYSTEM, 'supplier')
